import { getNewCardNumber } from 'redux/actions/cards';
import types from '../actionTypes';

const INITIAL_STATE = {
  isFetchingParkingList: false,
  isFetchingCardNumbers: false,
  isActivating: false,
  isBlocking: false,
  isCreating: false,
  isUpdating: false,
  isSynchronising: false,
  isAccessChanging: false,
  isGettingDetail: false,
  isGettingPrice: false,
  isFetchingParkingCardGroups: false,
  isGetNewCardNumber: false,
  isQrCode: false,

  parkingCards: [],
  parkingLTCards: [],
  parkingSTCards: [],
  parkingLTCardNumbers: [],
  parkingSTCardNumbers: [],
  cardDetail: {},
  cardPrice: {},
  parkingCardGroups: [],
  newCardNumber: '',
  qrCode: '',

  parkingCardNumbers: {
    LT: [],
    ST: [],
  },

  cardsPaging: {
    LT: {
      pageSize: 5,
      currentPage: 0,
      totalSize: 0,
    },
    ST: {
      pageSize: 5,
      currentPage: 0,
      totalSize: 0,
    },
    pageSize: 5,
    currentPage: 0,
    totalSize: 0,
  },

  errors: '',
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.PARKING_CARDS_FETCH_REQUEST:
      return {
        ...state,
        isFetchingParkingList: true,
      };
    case types.PARKING_CARDS_FETCH_SUCCESS:
      return {
        ...state,
        isFetchingParkingList: false,
        parkingCards: action.payload.parkingCards ? action.payload.parkingCards: [...action.payload.parkingLTCards, action.payload.parkingSTCards],
        parkingLTCards: action.payload.parkingLTCards,
        parkingSTCards: action.payload.parkingSTCards,
        cardsPaging: action.payload.cardsPaging,
      };
    case types.PARKING_CARDS_FETCH_FAIL:
      return {
        ...state,
        isFetchingParkingList: false,
        errors: action.payload.error,
      };

    case types.CARD_ACTIVATE_REQUEST:
      return {
        ...state,
        isActivating: true,
      };
    case types.CARD_ACTIVATE_SUCCESS:
      return {
        ...state,
        isActivating: false,
        cardDetail: action.payload.cardDetail,
        parkingCards: [...action.payload.parkingLTCards, action.payload.parkingSTCards],
        parkingLTCards: action.payload.parkingLTCards,
        parkingSTCards: action.payload.parkingSTCards,
      };
    case types.CARD_ACTIVATE_FAIL:
      return {
        ...state,
        isActivating: false,
        errors: action.payload.error,
      };

    case types.CARD_BLOCK_REQUEST:
      return {
        ...state,
        isBlocking: true,
      };
    case types.CARD_BLOCK_SUCCESS:
      return {
        ...state,
        isBlocking: false,
        cardDetail: action.payload.cardDetail,
        parkingCards: [...action.payload.parkingLTCards, action.payload.parkingSTCards],
        parkingLTCards: action.payload.parkingLTCards,
        parkingSTCards: action.payload.parkingSTCards,
      };
    case types.CARD_BLOCK_FAIL:
      return {
        ...state,
        isBlocking: false,
        errors: action.payload.error,
      };

    case types.CARD_CREATE_REQUEST:
      return {
        ...state,
        isCreating: true,
      };
    case types.CARD_CREATE_SUCCESS:
      return {
        ...state,
        isCreating: false,
        parkingCards: [...action.payload.parkingLTCards, action.payload.parkingSTCards],
        parkingLTCards: [...action.payload.parkingLTCards],
        parkingSTCards: [...action.payload.parkingSTCards],
      };
    case types.CARD_CREATE_FAIL:
      return {
        ...state,
        isCreating: false,
        errors: action.payload.error,
      };

    case types.CARD_ACCESS_CHANGE_REQUEST:
      return {
        ...state,
        isAccessChanging: true,
      };
    case types.CARD_ACCESS_CHANGE_SUCCESS:
      return {
        ...state,
        isAccessChanging: false,
        cardDetail: action.payload.data,
      };
    case types.CARD_ACCESS_CHANGE_FAIL:
      return {
        ...state,
        isAccessChanging: false,
        errors: action.payload.error,
      };
  
    case types.CARD_UPDATE_REQUEST:
      return {
        ...state,
        isUpdating: true,
      };
    case types.CARD_UPDATE_SUCCESS:
      return {
        ...state,
        isUpdating: false,
        cardDetail: action.payload.data,
        parkingCards: [...action.payload.parkingLTCards, action.payload.parkingSTCards],
        parkingLTCards: [...action.payload.parkingLTCards],
        parkingSTCards: [...action.payload.parkingSTCards],
      };
    case types.CARD_UPDATE_FAIL:
      return {
        ...state,
        isUpdating: false,
        errors: action.payload.error,
      };

    case types.CARD_DETAIL_REQUEST:
      return {
        ...state,
        isGettingDetail: true,
      };
    case types.CARD_DETAIL_SUCCESS:
      return {
        ...state,
        isGettingDetail: false,
        cardDetail: action.payload.cardDetail,
      };
    case types.CARD_DETAIL_FAIL:
      return {
        ...state,
        cardDetail: {},
        isGettingDetail: false,
        errors: action.payload.error,
      };

    case types.CARD_PRICE_REQUEST:
      return {
        ...state,
        isGettingPrice: true,
      };
    case types.CARD_PRICE_SUCCESS:
      return {
        ...state,
        isGettingPrice: false,
        cardPrice: action.payload.cardPrice,
      };
    case types.CARD_PRICE_FAIL:
      return {
        ...state,
        cardPrice: {},
        isGettingPrice: false,
        errors: action.payload.error,
      };

    case types.CARD_EDIT_BULK_REQUEST:
      return {
        ...state,
        isUpdating: true,
      };
    case types.CARD_EDIT_BULK_SUCCESS:
      return {
        ...state,
        isUpdating: false,
        parkingCards: [...action.payload.parkingLTCards, action.payload.parkingSTCards],
        parkingLTCards: action.payload.parkingLTCards,
        parkingSTCards: action.payload.parkingSTCards,
      };
    case types.CARD_EDIT_BULK_FAIL:
      return {
        ...state,
        isUpdating: false,
        errors: action.payload.error,
      };

    case types.PARKING_CARD_NUMBERS_FETCH_REQUEST:
      return {
        ...state,
        isFetchingCardNumbers: true,
      };
    case types.PARKING_CARD_NUMBERS_FETCH_SUCCESS:
      return {
        ...state,
        isFetchingCardNumbers: false,
        parkingCardNumbers: {
          LT: action.payload.parkingLTCardNumbers,
          ST: action.payload.parkingSTCardNumbers,
        },
      };
    case types.PARKING_CARD_NUMBERS_FETCH_FAIL:
      return {
        ...state,
        isFetchingCardNumbers: false,
        errors: action.payload.error,
      };

    case types.PARKING_CARD_GROUPS_FETCH_REQUEST:
      return {
        ...state,
        isFetchingParkingCardGroups: true,
      };
    case types.PARKING_CARD_GROUPS_FETCH_SUCCESS:
      return {
        ...state,
        isFetchingParkingCardGroups: false,
        parkingCardGroups: action.payload.parkingCardGroups,
      };
    case types.PARKING_CARD_GROUPS_FETCH_FAIL:
      return {
        ...state,
        isFetchingParkingCardGroups: false,
        errors: action.payload.error,
      };

    case types.CARD_SYNCH_REQUEST:
      return {
        ...state,
        isSynchronising: true,
      };
    case types.CARD_SYNCH_SUCCESS:
      return {
        ...state,
        isSynchronising: false,
      };
    case types.CARD_SYNCH_FAIL:
      return {
        ...state,
        isSynchronising: false,
        errors: action.payload.error,
      };

    case types.CARD_NEW_NUMBER_REQUEST:
      return {
        ...state,
        isGetNewCardNumber: true,
      };
    case types.CARD_NEW_NUMBER_SUCCESS:
      return {
        ...state,
        isGetNewCardNumber: false,
        newCardNumber: action.payload.newCardNumber
      };
    case types.CARD_NEW_NUMBER_FAIL:
      return {
        ...state,
        isGetNewCardNumber: false,
        errors: action.payload.error,
        newCardNumber: ''
      };

    case types.CARD_QR_REQUEST:
      return {
        ...state,
        isQrCode: true,
      };
    case types.CARD_QR_SUCCESS:
      return {
        ...state,
        isQrCode: false,
        qrCode: action.payload.qrCode
      };
    case types.CARD_QR_FAIL:
      return {
        ...state,
        isQrCode: false,
        errors: action.payload.error,
        qrCode: ''
      };

    default:
      return state;
  }
};
